// extracted by mini-css-extract-plugin
export var askAiIcon = "_s1-9";
export var container = "_s1-0";
export var groupSeparator = "_s1-a";
export var highlight = "_s1-4";
export var resultIcon = "_s1-5";
export var resultItem = "_s1-7";
export var resultSubtitle = "_s1-3";
export var resultTitle = "_s1-2";
export var resultsList = "_s1-1";
export var searchGroup = "_s1-6";
export var selected = "_s1-8";